import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

import { useAuth } from '@/modules/Auth/hooks/useAuth';
import queryKeys from '@/modules/shared/query/queryKeys';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function updateTeamMember(
  payload: { email: string; firstName?: string; lastName?: string; role?: string },
  token: string | undefined,
) {
  const response = await axios.put(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/team-members`,
    {
      email: payload.email,
      firstName: payload.firstName,
      lastName: payload.lastName,
      role: payload.role,
    },
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data;
}

export function useUpdateTeamMember() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  return useMutation<
    unknown,
    Error,
    { username: string; givenName?: string; familyName?: string; userRole?: string }
  >(
    (data) =>
      updateTeamMember(
        {
          email: data.username,
          firstName: data.givenName,
          lastName: data.familyName,
          role: data.userRole,
        },
        user?.signInUserSession.idToken.jwtToken,
      ),
    {
      onSuccess: () => {
        queryClient.refetchQueries([queryKeys.teamMembers]);
      },
    },
  );
}
